export default __webpack_public_path__ + "static/media/remove_frame_icon.5a32e27c.svg";